module.exports = __webpack_public_path__ + "f8137a63210014accfc51d72989bdbf7.svg";